import {useEffect, useState} from 'react'
import analyticsService from 'services/analytic'
import {useGenerateClientLinkMutation, useI18n} from 'store/Store'

const useClientsScreen = () => {
    const {i18n} = useI18n()
    const [snackbarText, setSnackbarText] = useState()
    const [loading, setLoading] = useState({})
    const [quotaError, setQoutaError] = useState(null)

    const [
        doGenerateLink,
        {data: generateLinkResponse, error: generateLinkError},
    ] = useGenerateClientLinkMutation()

    useEffect(() => {
        if (generateLinkResponse) {
            if (generateLinkResponse?.data?.success === false) {
                setSnackbarText(
                    generateLinkResponse?.data?.message ||
                        generateLinkResponse?.data?.msg
                )
                return
            }
            setSnackbarText(
                i18n.t('clientRequests.sendRequestUrlSuccessMessage')
            )
        }
    }, [generateLinkResponse, i18n])

    useEffect(() => {
        // if (generateLinkError) {
        //     setSnackbarText(
        //         generateLinkError?.data?.message || generateLinkError?.data?.msg
        //     )

        // }
        if (generateLinkError) {
            setQoutaError(
                generateLinkError?.data?.message || generateLinkError?.data?.msg
            )
        }
    }, [generateLinkError, i18n])

    const closeSnackbar = () => {
        setSnackbarText()
    }

    const generateLink = async (data) => {
        setLoading({...loading, [data.PlannerClientKey]: true})
        try {
            await doGenerateLink(data)
        } catch (e) {
            console.log('generate link error', e)
        }
        setLoading({...loading, [data.PlannerClientKey]: false})
        analyticsService.clientsPressed('send_request')
    }

    return {
        generateLink,
        doGenerateLink,
        snackbarText,
        closeSnackbar,
        loading,
        quotaError,
        setQoutaError,
    }
}

export default useClientsScreen
